export default "__VITE_ASSET__DZ7SW51s__"